module.exports = __webpack_public_path__ + "img/CZ45244782.66935c28.png";